import{
  useState,
  useRef
} from "react";
import './App.css';
import React from 'react';

function App() {
  const inputRef = useRef(null);
  const resultRef = useRef(null);
  const [result,setResult] = useState(0);

  function plus(e){
    e.preventDefault();
    setResult((result) => result + Number(inputRef.current.value));
  };

  function minus(e){
    e.preventDefault();
    setResult((result) => result - Number(inputRef.current.value));
  }

  function times(e){
    e.preventDefault();
    setResult((result) => result * Number(inputRef.current.value));
  }

  function divide(e){
    e.preventDefault();
    setResult((result) => result / Number(inputRef.current.value));
  }

  function resetInput(e){
    e.preventDefault();
    inputRef.current.value = 0;
  }
  
  function resetResult(e){
    e.preventDefault();
    setResult(0);
  }
  return (
    <div className="App">
      <div>
        <h1>Simplest Working Calculator</h1>
        <form>
          <p ref={resultRef}>{result}</p>
          <input
            pattern="[0-9]"
            ref={inputRef}
            type="number"
            placeholder="Type a number"
          />

          <button onClick={plus}>add</button>
          <button onClick={minus}>Subtract</button>
          <button onClick={times}>multiply</button>
          <button onClick={divide}>divide</button>
          <button onClick={resetInput}>inputReset</button>
          <button onClick={resetResult}>resultReset</button>
        </form>
      </div>
    </div>
  );
}

export default App;
